import React from "react";
import digitalI from '../../images/home/digital-marketing.png';

function DigitalMarketing() {
  return (
    <>

      <Hero />

      <section className="service-content-section">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <img
                src={digitalI}
                alt="Digital Marketing and SEO"
                className="service-main-image"
              />
            </div>

            <div className="col-lg-6">
              <div className="service-content">

                <h2>Make Your Business More Visible Online</h2>

                <p>
                  A strong digital presence can help businesses reach new
                  customers and build awareness of their products and services.
                </p>

                <p>
                  We focus on SEO and social media strategies designed around
                  your business, audience, industry, and online goals.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="service-features-section">
        <div className="container">
          <div className="section-heading text-center">

            <h2>Digital Marketing Services</h2>
          </div>

          <div className="row g-4">
            {[
              ["SEO", "Improve your website's visibility and help potential customers discover your business."],
              ["Social Media", "Build an active social presence and communicate with your target audience."],
              ["Online Presence", "Create a consistent digital presence that supports your overall business goals."]
            ].map(([title, text]) => (
              <div className="col-lg-4 col-md-6" key={title}>
                <div className="service-feature-card">
                  <h3>{title}</h3>
                  <p>{text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTA />
    </>
  );
}

function Hero() {
  return (
    <section
      className="service-page-hero"
      style={{ backgroundColor: '#002952' }}
    >
      <div className="container">
        <div className="service-hero-content">

          <h1>Digital Marketing & SEO</h1>
          <p style={{ color: '#FF7D37' }}>
            Improve your online visibility and connect your business with the
            right audience.
          </p>
        </div>
      </div>
    </section>
  );
}

function CTA() {
  return (
    <section className="service-cta-section">
      <div className="container">
        <div className="service-cta-box">
          <div>
            <span>GROW ONLINE</span>
            <h2>Want To Grow Your Online Presence?</h2>
            <p>Let's discuss your digital marketing goals.</p>
          </div>
          <a href="/contactus" className="service-cta-button">
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
}

export default DigitalMarketing;